module.exports = __webpack_public_path__ + "static/media/helmet.223db1ca.png";